import styled from 'styled-components';
import { lightenDarkenColor } from '../../shared/utils/styles';
import { GRAY, MessageWrapper, RED } from './../Styles';

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  & input {
    height: 30px;
    font-weight: 800;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  & hr {
    height: 3px;
    width: 25%;
    background-color: ${GRAY};
    border: none;
    margin-bottom: -5px;
  }
`;

export const SettingsContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  border: 4px solid ${GRAY};
  border-radius: 8px;
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(200px, 250px) auto;
`;

export const StyledButton = styled(MessageWrapper)`
  display: flex;
  justify-content: center;
  font-family: 'Inter', sans-serif;
  font-size: clamp(0.7rem, 0.8vw, 0.9rem);
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 8px;
  border: none;
  &:hover {
    background-color: ${({ bgColor }) => lightenDarkenColor(bgColor, 20)};
    background-color: ${({ bgColor }) =>
      bgColor === RED && lightenDarkenColor(bgColor, 50)};
  }
`;
